import { useState } from 'react';
import { fetchExperiences } from '../../services/api';
import { createExperience, updateExperience, deleteExperience } from '../../services/adminApi';
import { useCrudResource } from '../../hooks/useCrudResource';
import Button from '../../components/admin/ui/Button';
import Loader from '../../components/admin/ui/Loader';
import EntityTable from '../../components/admin/EntityTable';
import EntityForm from '../../components/admin/EntityForm';
import EntityFormPage from '../../components/admin/EntityFormPage';
import { experienceColumns, experienceFields } from '../../config/admin/experiences.config';
import { extractYear } from '../../utils/extractYear';

function AdminExperiencesPage({ showToast }) {
  const { items: experiences, loading, createItem, updateItem, removeItem } = useCrudResource(
    { fetchAll: fetchExperiences, create: createExperience, update: updateExperience, remove: deleteExperience },
    { showToast, entityLabel: 'Expérience' }
  );
  const [editing, setEditing] = useState(null);
  const [view, setView] = useState('list');

  const openCreate = () => {
    setEditing(null);
    setView('form');
  };

  const openEdit = (experience) => {
    setEditing(experience);
    setView('form');
  };

  const handleSubmit = async (values) => {
    if (editing) {
      await updateItem(editing.id, values);
    } else {
      await createItem(values);
    }
    setView('list');
  };

  const handleDelete = async (experience) => {
    if (!window.confirm('Supprimer cette expérience ?')) return;
    await removeItem(experience.id);
  };

  if (loading) return <Loader label="Chargement des expériences..." />;

  if (view === 'form') {
    return (
      <EntityFormPage
        listLabel="Expériences"
        itemLabel={editing ? editing.title?.fr || editing.title?.en : null}
        title={editing ? "Modifier l'expérience" : 'Ajouter une expérience'}
        onBack={() => setView('list')}
      >
        <EntityForm
          key={editing?.id ?? 'new'}
          fields={experienceFields}
          initialValues={editing || {}}
          onSubmit={handleSubmit}
          submitLabel={editing ? 'Sauvegarder' : 'Créer'}
        />
      </EntityFormPage>
    );
  }

  return (
    <section className="admin-section">
      <div className="admin-actions" style={{ justifyContent: 'space-between', marginBottom: 'var(--space-3)' }}>
        <h2>Expériences professionnelles</h2>
        <Button onClick={openCreate}>+ Ajouter</Button>
      </div>

      <EntityTable
        columns={experienceColumns}
        rows={experiences}
        onEdit={openEdit}
        onDelete={handleDelete}
        emptyMessage="Aucune expérience."
        searchPlaceholder="Rechercher une expérience..."
        searchFilter={(row, needle) =>
          (row.title?.fr || '').toLowerCase().includes(needle) || (row.title?.en || '').toLowerCase().includes(needle)
        }
        yearRangeFilter={{ getYear: (row) => extractYear(row.date?.fr) }}
      />
    </section>
  );
}

export default AdminExperiencesPage;
